import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getReceivers as getReceiversApi,
  getReceiversGetFilters as getReceiversGetFiltersApi,
  getReceiversGetFiltersExport as getReceiversGetFiltersExportApi,
  addNewReceiver as addNewReceiverApi,
  addNewReceiverClient as addNewReceiverClientApi,
  updateReceiver as updateReceiverApi,
  deleteReceiver as deleteReceiverApi,
} from "../../helpers/realbackend_helper";

export const getReceivers = createAsyncThunk(
  "receiver/getReceivers",
  async ({ container_id, container_number }, { rejectWithValue }) => {
    // console.log("Thunk received container_number:", container_number);
    // console.log("Thunk received container_id:", container_id);

    try {
      const response = await getReceiversApi({
        container_id,
        container_number,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getReceiversGetFilters = createAsyncThunk(
  "receiver/getReceiversGetFilters",
  async (filters, thunkAPI) => {
    try {
      const response = await getReceiversGetFiltersApi(filters);
      return response;
    } catch (error) {
      console.error("Error fetching receivers:", error);
      return thunkAPI.rejectWithValue(
        error.response || error.message || "Error fetching receivers"
      );
    }
  }
);

export const getReceiversGetFiltersExport = createAsyncThunk(
  "receiver/getReceiversGetFiltersExport",
  async (filters, thunkAPI) => {
    try {
      const response = await getReceiversGetFiltersExportApi(filters);
      return response;
    } catch (error) {
      console.error("Error fetching receivers:", error);
      return thunkAPI.rejectWithValue(
        error.response || error.message || "Error fetching receivers"
      );
    }
  }
);

// Серверийн алдааг уншиж болохуйц мессеж болгоно. axios interceptor нь
// ихэвчлэн шууд string reject хийдэг.
const toReceiverErrorMessage = (error) =>
  (typeof error === "string" && error) ||
  error?.message ||
  error?.data?.message ||
  "Мэдээллийг нэмэхэд алдаа гарлаа!";

export const addNewReceiver = createAsyncThunk(
  "receiver/addNewReceiver",
  async (receiver, { rejectWithValue }) => {
    try {
      // await заавал хэрэгтэй. Өмнө нь байхгүй байсан тул хүсэлт дуусахаас
      // өмнө "амжилттай хадгаллаа" гэж мэдэгдээд, catch нь ямар ч алдаа
      // барьж чаддаггүй байв — хэрэглэгч хадгалагдаагүй үед ч амжилттай
      // гэсэн мэдэгдэл хардаг байсны үндсэн шалтгаан.
      const response = await addNewReceiverApi(receiver);
      toast.success("Мэдээллийг амжилттай хадгаллаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      const message = toReceiverErrorMessage(error);
      toast.error(message, {
        autoClose: 5000,
      });
      return rejectWithValue(message);
    }
  }
);

export const addNewReceiverSilent = createAsyncThunk(
  // Тайлбар: action type-ыг addNewReceiver-тэй ижил хэвээр үлдээв — reducer-ийн
  // одоогийн ажиллагааг өөрчлөхгүйн тулд. Энд зөвхөн await/reject-ийг зассан.
  "receiver/addNewReceiver",
  async (receiver, { rejectWithValue }) => {
    try {
      const response = await addNewReceiverApi(receiver);
      return response;
    } catch (error) {
      return rejectWithValue(toReceiverErrorMessage(error));
    }
  }
);

export const addNewReceiverClient = createAsyncThunk(
  "receiver/addNewReceiverClient",
  async (receiver) => {
    try {
      const response = addNewReceiverClientApi(receiver);
      toast.success("Мэдээллийг амжилттай хадгаллаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Мэдээллийг нэмэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateReceiver = createAsyncThunk(
  "receiver/updateReceiver",
  async (receiver) => {
    try {
      const response = updateReceiverApi(receiver);
      toast.success("Мэдээллийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Мэдээллийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteReceiver = createAsyncThunk(
  "receiver/deleteReceiver",
  async (receiver) => {
    try {
      const response = deleteReceiverApi(receiver);
      toast.success("Мэдээллийг амжилттай устгалаа", {
        autoClose: 3000,
      });
      return { receiver, ...response };
    } catch (error) {
      toast.error("Мэдээллийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);
